export default defineNuxtRouteMiddleware((to) => {
  const url = useRequestURL();
  const env = useRuntimeConfig();

  const landingPagesRoutes = [
    "/cases-de-sucesso",
    "/oportunidades",
    "/originadoras",
    "/parceiros",
    "/politica-de-privacidade",
    "/quem-somos",
    "/remocao-de-conta",
    "/termos-de-uso",
    "/tokenizacao",
  ];

  const isLandingPage = landingPagesRoutes.some((route) =>
    to.path.startsWith(route),
  );

  if (
    isLandingPage ||
    (to.path === "/" && !url.hostname.includes("localhost"))
  ) {
    return navigateTo(`${env.public.hurstUrl}${to.path}`, { external: true });
  }
});
